"use client";

import React from "react";
import { fadeInAnimate } from "utils/animation";

interface KeywordListProps {
    keywords: string[];
}

const KeywordList: React.FC<KeywordListProps> = ({ keywords }) => {
    return (
        <div>
            {/* Conditionally render content based on keywords */}
            {keywords && keywords.length > 0 ? (
                <>
                    <h3>
Your Industry{keywords.length> 0  ? " Keywords:": ":" }              </h3>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: 20 }}>
                        {keywords.map((kw, index) => (
                            <span
                                key={index}
                                style={{
                                    color: "#111",
                                    padding: "4px 16px",
                                    backgroundColor: "#a5a5d9",
                                    borderRadius: "9999px",
                                    fontSize: "0.5rem",
                                }}
                            >
                                {kw}
                            </span>
                        ))}
                    </div>
                </>
            ) : (
                <p>No keywords available for this site.</p>
            )}
        </div>
    );
};

export default KeywordList;
